import React, { Children } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ButtonGroup from '@xingternal/malt-button-group';

import styles from './StretchButtonGroup.css';

const StretchButtonGroup = ({ children: childComponents, className }) => (
  <ButtonGroup className={classNames(styles.stretchButtonGroup, className)}>
    {Children.map(childComponents, childComponent =>
      childComponent
        ? {
            ...childComponent,
            props: {
              ...childComponent.props,
              className: classNames(
                styles.stretchButton,
                childComponent.props.className
              ),
            },
          }
        : null
    )}
  </ButtonGroup>
);

StretchButtonGroup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default StretchButtonGroup;
